import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { api, formatWIB } from "@/lib/api";

export function NotificationBell() {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const ref = useRef(null);
  const navigate = useNavigate();

  const loadCount = useCallback(async () => {
    try { const { data } = await api.get("/notifications/unread-count"); setCount(data.count); } catch { /* silent */ }
  }, []);

  useEffect(() => { loadCount(); const t = setInterval(loadCount, 60000); return () => clearInterval(t); }, [loadCount]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const toggle = async () => {
    const n = !open; setOpen(n);
    if (n) { try { const { data } = await api.get("/notifications", { params: { page_size: 5 } }); setItems(data.items); } catch { /* silent */ } }
  };

  const openItem = async (it) => {
    try { await api.patch(`/notifications/${it.id}/read`); } catch { /* silent */ }
    setOpen(false); loadCount(); navigate(it.target_url || "/dashboard");
  };

  return (
    <div className="relative shrink-0" ref={ref}>
      <button onClick={toggle} data-testid="notif-bell" className="relative p-2 rounded-lg hover:bg-slate-100 text-slate-600" title="Notifikasi">
        <Bell className="h-5 w-5" />
        {count > 0 && <span data-testid="notif-badge" className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#f97316] text-white text-[10px] font-bold grid place-items-center">{count > 99 ? "99+" : count}</span>}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-80 max-w-[calc(100vw-2rem)] bg-white border border-slate-200 rounded-xl shadow-lg z-50" data-testid="notif-dropdown">
          <div className="px-4 py-2 border-b border-slate-100 text-sm font-semibold text-slate-700">Notifikasi</div>
          <div className="max-h-96 overflow-y-auto">
            {items.length === 0 ? <div className="px-4 py-6 text-center text-sm text-slate-400">Belum ada notifikasi.</div>
              : items.map((it) => (
                <button key={it.id} onClick={() => openItem(it)} data-testid={`notif-item-${it.id}`} className={`w-full text-left px-4 py-3 border-b border-slate-100 hover:bg-slate-50 ${it.is_read ? "" : "bg-orange-50/40"}`}>
                  <div className="flex items-start gap-2">
                    {!it.is_read && <span className="mt-1.5 h-2 w-2 rounded-full bg-[#f97316] shrink-0" />}
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-slate-800 truncate">{it.title}</p>
                      <p className="text-xs text-slate-500 line-clamp-2">{it.message}</p>
                      <p className="text-[11px] text-slate-400 mt-0.5">{formatWIB(it.created_at)}</p>
                    </div>
                  </div>
                </button>
              ))}
          </div>
          <button onClick={() => { setOpen(false); navigate("/notifikasi"); }} data-testid="notif-see-all" className="w-full text-center py-2.5 text-sm font-medium text-[#0f2847] hover:bg-slate-50 rounded-b-xl border-t border-slate-100">Lihat Semua Notifikasi</button>
        </div>
      )}
    </div>
  );
}
